require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-you-can-learn-to-develop-iphone-and-ipad-apps.json") })
        }
      }, "path---blog-you-can-learn-to-develop-iphone-and-ipad-apps");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-you-can-learn-to-develop-iphone-and-ipad-apps!./.cache/json/blog-you-can-learn-to-develop-iphone-and-ipad-apps.json
// module id = 1128
// module chunks = 231608221292675